import * as Yup from 'yup';
import { IModel } from '~/lib/model';

export interface ISourceDomains extends IModel {
    id: string;
    domain: string;
    bundles: string;
    isDefault: boolean;
    customId: string | null;
}

export const SourceDomainsSchema = Yup.object().shape<ISourceDomains>({
    id: null,
    bundles: Yup.string()
        .transform((value) => ((value === null) || (value === undefined) ? '' : value))
        .when('isDefault', {
            is: true,
            then: Yup.string(),
            otherwise: Yup.string().required()
        }),
    domain: Yup.string()
        .matches(/^([\w-]+[.])+([\w-])+$/, 'Invalid domain format (e.g. domain.com)')
        .required(),
    isDefault: Yup.boolean().required(),
    customId: Yup.string()
        .transform(value => {
            if (value == null) return null;
            if (typeof value === 'string' && value.trim() === '') return null;
            return value;
        })
        .nullable(true)
        .notRequired()
        .test(
            'no-surrounding-whitespace',
            'Custom ID must not have leading or trailing whitespace',
            value => value == null || value === value.trim()
        ),
});

export const defaultSourceDomain: ISourceDomains = {
    id: null,
    domain: 'example.com',
    bundles: '',
    isDefault: false,
    customId: null,
};
